import React, { Component } from 'react';
import moment from 'moment';

import TinyNodeSensorSettingsForm from './TinyNodeSensorSettingsForm';

import { defaultSorter, dateSorter } from './Helpers';
import TinyNodeSensorsModel from './TinyNodeSensorsModel';
import UserModel from './UserModel';

import { Table, Badge, Row, Col, Statistic, Popconfirm, Divider, message, Typography } from 'antd';

class PlaceRolesTable extends Component {

  state = {
    children: [],
    filteredInfo: {},
    sortedInfo: {},
    tinyNodeSensorSettingsFormData: null
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  }

  render() {

    let { sortedInfo, filteredInfo } = this.state;

    const columns = [{
      title: 'Kód',
      dataIndex: 'code',
      key: 'code',
      width: 150,
      defaultSortOrder: 'ascend',
      sorter: (a, b) => defaultSorter(a.code, b.code)
    }, {
      title: 'Název',
      dataIndex: 'name',
      key: 'name',
      defaultSortOrder: 'ascend',
      sorter: (a, b) => defaultSorter(a.name, b.name)
    }, {
      title: 'Akce',
      key: 'Action',
      width: 200,
      render: (text, record) => {
        if (UserModel.isInRoles(['ADMIN', 'CORE_PLACEROLES_WRITE'])) {
          return (
            <div>
              <Popconfirm placement="right" title="Opravdu si přejete záznam smazat?" onConfirm={() => {
                this.props.onRemoveRow
                  ? this.props.onRemoveRow(record.id)
                  : null;
              }} okText="Ano" cancelText="Ne">
                <a onClick={(e) => { e.preventDefault(); }}><Typography.Text type="danger">Smazat</Typography.Text></a>
              </Popconfirm>
            </div>
          );
        }
      }
    }];

    return (
      <div>
        <Table
          size='small'
          rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
          loading={this.props.loading ? this.props.loading : false}
          columns={columns}
          dataSource={this.props.data}
          onChange={this.handleChange}
          pagination={{
            showSizeChanger: true,
            defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
              ? parseInt(localStorage.getItem('table_pageSize'))
              : 10,
            onShowSizeChange: (current, size) => {
              localStorage.setItem('table_pageSize', size);
            }
          }}
          style={{ border: '0px' }} />
      </div>
    );
  }
}

export default PlaceRolesTable;


// WEBPACK FOOTER //
// ./src/components/PlaceRolesTable.js